import initAdyenCheckout from '@adyen/adyen-web';
import { getAdyenCommonConfig } from './adyenBasePayments';
import { AdyenDisableStoredPaymentRequest } from '../types/adyenDisableStoredPaymentRequest';
import { PayServiceApi } from '../../../api/PayServiceApi';
import { generateMailForm } from '../paymentsHelper';
import { validateEmail } from '../../../utils/helpers';
import { CurrentUser } from '../../modules/user/currentUser';


const PAYMENT_METHODS_CONFIG = {

    card: {
        configuration: {},
        enableStoreDetails: true,
        hasHolderName: true,
        holderNameRequired: true,
        styles: {
            base: {
                color: '#4c2727',
                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                fontSize: '16px',
                fontSmoothing: 'antialiased'
            },
            placeholder: {
                color: '#91785D'
            }
        }
    },
    paypal: {
        blockPayPalPayLaterButton: true
    },
    storedCard: {
        styles: {
            placeholder: {
                color: '#91785D'
            }
        }
    }
};
enum emailRequiredMethodTypes {
    onlineBankingPL = 'onlineBanking_PL'
}
export async function showDropInComponent(): Promise<void> {
    const type = 'dropin';
    const methodsContainer = document.querySelector('#order_box_wrapper');
    const container = document.createElement('div');
    container.className = 'ecommpay_variant adyen-dropIn scrollbar-rail';
    methodsContainer.append(container);
    $(container).scrollbar();

    const config = await getAdyenCommonConfig(type, null, true);
    config.showPayButton = true;
    config.translations = {};
    config.paymentMethodsConfiguration = PAYMENT_METHODS_CONFIG;

    if (window.app.config.payments.adyen.ssn_countries.includes(window.app.config.country)) {
        config.paymentMethodsConfiguration.card.configuration.socialSecurityNumberMode = 'show';
    }
    const email = CurrentUser.getInstance().getPaymentEmail();
    const checkout = await initAdyenCheckout(config);
    checkout.create(type, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onDisableStoredPaymentMethod: async(storedPaymentMethod: string, resolve: any, _reject: any) => {
            const disableStoredPaymentRequestData: AdyenDisableStoredPaymentRequest = {
                storedPaymentMethod,
                suid: CurrentUser.getInstance().getSuid()
            };
            await PayServiceApi.post('payments/adyen/disableStoredPayment', disableStoredPaymentRequestData);
            resolve();
        },
        showRemovePaymentMethodButton: true,
        onSelect: (component) => {
            if (component.props.type === emailRequiredMethodTypes.onlineBankingPL && !email) {
                $(container).remove();
                showEmailForm();
            }
        }
    }).mount(container);
}

function showEmailForm() {
    const methodsContainer = $('#order_box_wrapper');
    const mailForm = generateMailForm();

    const btn = mailForm.querySelector('button');
    btn.addEventListener('click', async()=>{
        const email: HTMLInputElement = mailForm.querySelector('input.email');
        if (validateEmail(email.value)) {
            const paymentInfoBlock = $('#ecommpay_order_box_popup_payment_variants');
            CurrentUser.getInstance().setPaymentEmail(email.value);
            mailForm.remove();
            paymentInfoBlock.hide();
            await showDropInComponent();
        } else {
            mailForm.classList.add('error');
        }
    });

    methodsContainer.append(mailForm);
}

